module.exports = __webpack_public_path__ + "fonts/open-sans-v15-cyrillic-regular.717cff6.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/open-sans-v15-cyrillic-regular.woff
// module id = FZ+N
// module chunks = 13